import apiService from './apiService';
import { setWhatsAppNumber, getWhatsAppNumber } from '../constants/contact';

/**
 * Coordonnées publiques de la boutique.
 *
 * Le numéro WhatsApp se règle en administration : le charger au démarrage
 * évite de reconstruire les fronts pour en changer. L'échec est sans gravité —
 * `getWhatsAppNumber` retombe sur la valeur du dernier chargement, puis sur
 * celle du code.
 */
class ContactService {
  async loadWhatsAppNumber() {
    try {
      const response = await apiService.get('/contact');
      const number = (response?.data?.data || response?.data || response)?.whatsapp_number;
      setWhatsAppNumber(number);
      return getWhatsAppNumber();
    } catch {
      // Numéro indisponible : on garde celui qu'on a déjà, sans bruit. Un toast
      // d'erreur ici n'apprendrait rien au client et masquerait la boutique.
      return getWhatsAppNumber();
    }
  }
}

const contactService = new ContactService();
export default contactService;
